import { Dispatch } from 'redux';
import { actionCreators } from './NBCState';
import { ImageInfo, NBCItem, NBCProfile } from '../../Interfaces/NBC/NBCItem';
import { DrilldownProfile, TreeViewDataItem } from '../../Interfaces/NBC/Drilldown';

export const fetchNBCItemsByID = async (
  dispatch: Dispatch<any>,
  profileID: number
) => {
  return dispatch(actionCreators.fetchNBCItemsByID(profileID));
};

export const addNewNBCItem = async (
  dispatch: Dispatch<any>,
  item: NBCItem[],
  profileID: number | undefined
) => {
  return dispatch(actionCreators.addNewNBCItem(item, profileID));
};

export const updateNBCItems = async (
  dispatch: Dispatch<any>,
  updateNBCItem: NBCItem[],
  profileID: number | undefined
) => {
  return dispatch(actionCreators.updateNBCItems(updateNBCItem, profileID));
};

export const getProfileNameList = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.getProfileNameList());
};

export const addNewProfile = async (
  dispatch: Dispatch<any>,
  newProfile: NBCProfile | undefined
) => {
  return dispatch(actionCreators.addNewNBCProfile(newProfile));
};

export const EditNBCProfile = async (
  dispatch: Dispatch<any>,
  newProfile: NBCProfile | undefined
) => {
  return dispatch(actionCreators.editNBCProfile(newProfile));
};

export const deleteNBCProfile = async (
  dispatch: Dispatch<any>,
  profileUuid: NBCProfile | undefined
) => {
  return dispatch(actionCreators.deleteNBCProfile(profileUuid));
};

export const resetFetchError = async (dispatch: any) => {
  return dispatch(actionCreators.resetFetchError());
};

export const overwriteNBCItem = async (
  dispatch: Dispatch<any>,
  item: NBCItem[],
  profileID: number | undefined
) => {
  return dispatch(actionCreators.OverwriteNBCItems(item, profileID));
};

export const importImages = async (
  dispatch: Dispatch<any>,
  files: ImageInfo[]
) => {
  return dispatch(actionCreators.importImages(files));
};

export const getAllNBCImages = async (dispatch: Dispatch<any>) => {
  return dispatch(actionCreators.getAllNBCImages());
};

export const resetNotificationMessage = async (dispatch: any) => {
  return dispatch(actionCreators.resetNotificationMessage());
};

export const applySnapshot = async (
  dispatch: any,
  profileInfo: NBCProfile | undefined,
  scheduledDateTime: string | undefined,
  applyNow: boolean,
  snapshotType:string,
) => {
  return dispatch(
    actionCreators.applySnapshot(profileInfo, scheduledDateTime, applyNow, snapshotType)
  );
};

export const deleteNBCItems = async (
  dispatch: Dispatch<any>,
  itemKeys: string[],
  profileID: number | undefined
) => {
  return dispatch(actionCreators.deleteNBCItems(itemKeys, profileID));
};

export const getDrilldownProfileByID = async (
  dispatch: Dispatch<any>,
  profileID: number | undefined,
) => {
  return dispatch(actionCreators.getDrilldownProfileByID(profileID));
};

export const deleteDrilldown = async (
  dispatch: Dispatch<any>,
  profileID: number | undefined,
  drilldownID:string
) => {
  return dispatch(actionCreators.deleteDrilldown(profileID, drilldownID));
};

export const deleteDrilldownItem = async (
  dispatch: Dispatch<any>,
  profileID: number | undefined,
  drilldownID:string,
  itemToDelete:string
) => {
  return dispatch(actionCreators.deleteDrilldownItem(profileID, drilldownID, itemToDelete));
};

export const getDrilldownItemByDrilldownID = async (
  dispatch: Dispatch<any>,
  profileID: number | undefined,
  drilldownID:string,
) => {
  return dispatch(actionCreators.requestDrilldownItemsByID(profileID, drilldownID));
};

export const addNewDrilldown = async (
  dispatch: Dispatch<any>,
  profileID: number | undefined,
  treeviewDataItem:TreeViewDataItem,
) => {
  return dispatch(actionCreators.addNewDrilldown(profileID, treeviewDataItem));
};

export const addItemToDrilldown = async (
  dispatch: Dispatch<any>,
  profileID: number | undefined,
  itemsToAdd:string[],
  drilldownID:string
) => {
  return dispatch(actionCreators.addItemToDrilldown(profileID, itemsToAdd, drilldownID));
};

export const getItemsGroups = async (
  dispatch: Dispatch<any>,
  profileID: number | undefined,
) => {
  return dispatch(actionCreators.getItemsGroups(profileID));
};

export const updateDrilldown= async (
  dispatch: Dispatch<any>,
  item: TreeViewDataItem,
  profileID: number | undefined,
  prevDrilldownName:string
) => {
  return dispatch(actionCreators.updateDrilldown(item, profileID, prevDrilldownName));
};

export const editItemsGroups = async (
  dispatch: Dispatch<any>,
  profileID: number | undefined,
  groupUuid:string | undefined,
  updatedGroupName:string | undefined
) => {
  return dispatch(actionCreators.editItemsGroups(profileID, groupUuid, updatedGroupName));
};

export const deleteItemsGroups = async (
  dispatch: Dispatch<any>,
  profileID: number | undefined,
  groupUuid:string | undefined,
) => {
  return dispatch(actionCreators.deleteItemsGroups(profileID, groupUuid));
};

export const addItemsGroups = async (
  dispatch: Dispatch<any>,
  profileID: number | undefined,
  groupName:string,
) => {
  return dispatch(actionCreators.addItemsGroups(profileID, groupName));
};

export const updateDrilldownItemPositionByDrilldownID = async (
  dispatch: Dispatch<any>,
  profileID: number | undefined,
  drilldownID:string | null,
  item:string[]
) => {
  return dispatch(actionCreators.updateDrilldownItemPositionByDrilldownID(profileID, drilldownID, item));
};


